import React from "react";
import { Table } from "react-bootstrap";
import { BsPencilSquare, BsTrash } from "react-icons/bs";

interface Item {
  id: number;
  ticket_group_code: string;
}

interface CurrentLatestTableProps {
  items: Item[];
  onDelete: (id: number) => void;
  onEdit: (id: number) => void;
}

export default function CurrentLatestSeatPlanTable({
  items,
  onDelete,
  onEdit,
}: CurrentLatestTableProps) {
  return (
    <Table hover>
      <thead className="bg-gray-200">
        <tr>
          <th>Ticket Group Code</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.id}>
            <td>{item.ticket_group_code}</td>
            <td>
              {/* Edit Button */}
              <button
                onClick={() => {
                  console.log("Edit button clicked for ID:", item.id);
                  onEdit(item.id);
                }}
                type="button"
                className="bg-blue-600 rounded-sm text-white text-xl mr-2"
              >
                <BsPencilSquare />
              </button>
              {/* Delete Button */}
              <button
                onClick={() => onDelete(item.id)}
                type="button"
                className="bg-red-600 rounded-sm text-white text-xl"
              >
                <BsTrash />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
